const ORGANIZATION_SESSIONS_UPDATED = (state, organization_sessions) => {
  state.organization_sessions = organization_sessions;
};

const ORGANIZATION_SESSIONS_VIEW_UPDATED = (
  state,
  organization_sessions_view
) => {
  state.organization_sessions_view = organization_sessions_view;
};

const ORGANIZATION_REVISIONS_UPDATED = (state, organization_revisions) => {
  state.organization_revisions = organization_revisions;
};

const ORGANIZATION_REVISIONS_VIEW_UPDATED = (
  state,
  organization_revisions_view
) => {
  state.organization_revisions_view = organization_revisions_view;
};

const ORGANIZATION_CREATE_REVISIONS_UPDATED = (
  state,
  organization_create_revisions
) => {
  state.organization_create_revisions = organization_create_revisions;
};

const ORGANIZATION_CREATE_REVISIONS_VIEW_UPDATED = (
  state,
  organization_create_revisions_view
) => {
  state.organization_create_revisions_view = organization_create_revisions_view;
};

const ORGANIZATION_UPDATE_REVISIONS_UPDATED = (
  state,
  organization_update_revisions
) => {
  state.organization_update_revisions = organization_update_revisions;
};

const ORGANIZATION_UPDATE_REVISIONS_VIEW_UPDATED = (
  state,
  organization_update_revisions_view
) => {
  state.organization_update_revisions_view = organization_update_revisions_view;
};

const ORGANIZATION_DESTROY_REVISIONS_UPDATED = (
  state,
  organization_destroy_revisions
) => {
  state.organization_destroy_revisions = organization_destroy_revisions;
};

const ORGANIZATION_DESTROY_REVISIONS_VIEW_UPDATED = (
  state,
  organization_destroy_revisions_view
) => {
  state.organization_destroy_revisions_view =
    organization_destroy_revisions_view;
};

const USER_REVISIONS_UPDATED = (state, user_revisions) => {
  state.user_revisions = user_revisions;
};

const USER_REVISIONS_VIEW_UPDATED = (state, user_revisions_view) => {
  state.user_revisions_view = user_revisions_view;
};

const USER_ACTIONS_UPDATED = (state, user_actions) => {
  state.user_actions = user_actions;
};

const USER_ACTIONS_VIEW_UPDATED = (state, user_actions_view) => {
  state.user_actions_view = user_actions_view;
};

const USER_REVISIONS_ERROR = (state, user_revisions_error) => {
  state.user_revisions_error = user_revisions_error;
};

const CHANGE_AUDIT_UPDATED = (state, change_audit) => {
  state.change_audit = change_audit;
};

const USER_LIST_UPDATED = (state, user_list) => {
  state.user_list = user_list;
};

const USER_LIST_VIEW_UPDATED = (state, user_list_view) => {
  state.user_list_view = user_list_view;
};

const USER_LIST_REMOVE_ITEM = (state, id) => {
  let i = state.user_list.data.findIndex((item) => item.id === id);
  state.user_list.data.splice(i, 1);
  state.user_list_view.total--;
};

const USER_LIST_ADD_ITEM = (state, user) => {
  state.user_list.data.push(user);
  state.user_list_view.total++;
};

const SET_BROADCASTS = (state, broadcasts) => {
  state.broadcasts = broadcasts;
};

const ADD_BROADCAST = (state, broadcast) => {
  state.broadcasts.data.push(broadcast.data);
};

const ADD_JOIN_REQUESTS = (state, items) => {
  state.join_requests = items;
};

const ADD_SIMPLE_JOIN_REQUESTS = (state, items) => {
  state.simple_join_requests = items;
};

const ADD_PACKETS = (state, items) => {
  state.packets = items;
};

const ADD_NETWORK_STATISTICS = (state, items) => {
  state.network_statistics = items;
};

const ADD_GATEWAY_STATISTICS = (state, items) => {
  state.gateway_statistics = items;
};

const ADD_JOIN_REQUESTS_QUANTITIES = (state, items) => {
  state.join_requests_quantities = items;
};

const ADD_PACKETS_QUANTITIES = (state, items) => {
  state.packets_quantities = items;
};

const ADD_STATS = (state, items) => {
  state.stats = items;
};

const ADD_CRC_ERRORS = (state, items) => {
  state.crc_errors = items;
};

const ADD_MISSED_PACKETS = (state, item) => {
  state.missed_packets = item;
};

const ADD_SEARCH_RESULTS = (state, item) => {
  state.search_results = item;
};

const ADD_SYSTEM_SUMMARY = (state, item) => {
  state.system_summary = item;
};

const SET_LICENSES = (state, payload) => {
  state.licenses_object = payload;
};
const SET_ORGANIZATION_SCHEDULE_PROVISIONING = (state, payload) => {
  state.organization_schedule_provisioning = payload;
};
const ADD_ORGANIZATION_SCHEDULE_PROVISIONING = (state, payload) => {
  state.organization_schedule_provisioning.push(payload);
};
const REMOVE_ORGANIZATION_SCHEDULE_PROVISIONING = (state, id) => {
  state.organization_schedule_provisioning.splice(
    state.organization_schedule_provisioning.findIndex((e) => e.id === id),
    1
  );
};

export default {
  SET_BROADCASTS,
  ADD_BROADCAST,
  ORGANIZATION_SESSIONS_UPDATED,
  ORGANIZATION_SESSIONS_VIEW_UPDATED,
  ORGANIZATION_REVISIONS_UPDATED,
  ORGANIZATION_REVISIONS_VIEW_UPDATED,
  ORGANIZATION_CREATE_REVISIONS_UPDATED,
  ORGANIZATION_CREATE_REVISIONS_VIEW_UPDATED,
  ORGANIZATION_UPDATE_REVISIONS_UPDATED,
  ORGANIZATION_UPDATE_REVISIONS_VIEW_UPDATED,
  ORGANIZATION_DESTROY_REVISIONS_UPDATED,
  ORGANIZATION_DESTROY_REVISIONS_VIEW_UPDATED,
  USER_REVISIONS_UPDATED,
  USER_REVISIONS_VIEW_UPDATED,
  USER_ACTIONS_UPDATED,
  USER_ACTIONS_VIEW_UPDATED,
  USER_REVISIONS_ERROR,
  CHANGE_AUDIT_UPDATED,
  USER_LIST_UPDATED,
  USER_LIST_VIEW_UPDATED,
  USER_LIST_REMOVE_ITEM,
  USER_LIST_ADD_ITEM,
  ADD_JOIN_REQUESTS,
  ADD_SIMPLE_JOIN_REQUESTS,
  ADD_PACKETS,
  ADD_NETWORK_STATISTICS,
  ADD_GATEWAY_STATISTICS,
  ADD_JOIN_REQUESTS_QUANTITIES,
  ADD_PACKETS_QUANTITIES,
  ADD_STATS,
  ADD_CRC_ERRORS,
  ADD_MISSED_PACKETS,
  ADD_SEARCH_RESULTS,
  ADD_SYSTEM_SUMMARY,
  SET_LICENSES,
  SET_ORGANIZATION_SCHEDULE_PROVISIONING,
  REMOVE_ORGANIZATION_SCHEDULE_PROVISIONING,
  ADD_ORGANIZATION_SCHEDULE_PROVISIONING,
};



// WEBPACK FOOTER //
// ./src/modules/organizationStates/store/mutations.js